import axios from '../config/api'
import router from '@/router'
import { getCampaignStaticPageSlug } from '@/config/campaignStaticPage'
const campaignType = process.env.VUE_APP_CAMPAIGN_TYPE ?? 'BNN'

// A call site passes either a literal slug, or { key } to let the current
// campaign decide which page it wants.
const resolveSlug = (rootState, payload) => {
  if (typeof payload === 'string') {
    return payload
  }

  const campaignSlug =
    payload?.campaignSlug ||
    // Order pages (/order-detail/:orderId, /checkout/:orderId, /thank/:uid)
    // have no :slug param, and campaign.current may be stale there; the
    // order payload carries the authoritative campaign.
    rootState.order.data?.campaign?.slug ||
    rootState.campaign.current?.data?.slug ||
    router?.history?.current?.params?.slug ||
    ''

  return getCampaignStaticPageSlug(campaignSlug, payload?.key)
}

// Bumped on every request and on clear(), so a response that arrives after
// the route changed (or after a newer request) is ignored.
let requestId = 0

const state = () => ({
  data: null,
  payload: null,
  isError: false,
  isLoading: false,
})

// getters
const getters = {
  isLoading: state => state.isLoading,
}

// actions
const actions = {
  async getStaticPage({ commit, rootState }, payload) {
    const currentRequestId = ++requestId
    const slug = resolveSlug(rootState, payload)

    if (!slug) {
      commit('setError')

      return
    }

    try {
      commit('setLoading', true)
      const res = await axios.get(
        `/static-page/${campaignType}/${slug}`,
      )

      if (currentRequestId !== requestId) return

      commit('setData', res.data.data)
    } catch {
      if (currentRequestId !== requestId) return

      commit('setError')
    }
  },

  clear({ commit }) {
    requestId++
    commit('reset')
  },
}

// mutations
const mutations = {
  setLoading(state, payload) {
    state.isLoading = payload
  },

  setData(state, payload) {
    state.isLoading = false
    state.isError = false
    state.data = payload
  },

  reset(state) {
    Object.assign(state, {
      data: null,
      payload: null,
      isError: false,
      isLoading: false,
    })
  },

  setError(state) {
    state.isLoading = false
    state.isError = true
    state.data = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
